import {useState} from "react"
import {usePrissoknader} from "../../api/prissoknader"
import {useResoknadStatus} from "../../api/resoknadstatus"
import {trekkHustandOgAlleAktivePrissoknader} from "../../api/trekkprissoknader"

function useAvsluttPrissoknad() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [isSuccess, setIsSuccess] = useState<boolean>()
  const [, , , invalidateResoknadStatus] = useResoknadStatus()
  const [, , , invalidateSoknader] = usePrissoknader()

  const avsluttPrissoknader = async () => {
    setLoading(true)
    setError(null)

    try {
      await trekkHustandOgAlleAktivePrissoknader()
      invalidateResoknadStatus()
      invalidateSoknader()
      setIsSuccess(true)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  return {loading, error, isSuccess, avsluttPrissoknader}
}

export default useAvsluttPrissoknad
